module.exports = __webpack_public_path__ + "img/certificate_17574570_00.8990ceff.png";